import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const VillaTierraPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const reserveSection = document.getElementById('reserve');
      if (reserveSection) {
        reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const images = [
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/7e9917d46f66bb91ac6d12464f0a3d30.jpeg',
      alt: 'Villa Tierra pool area with colorful architecture'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/ef627949531e2fb752321259ec07396d.jpeg',
      alt: 'Villa Tierra bedroom with rainbow mural and twin beds'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/584f1cf477938c2bd91899c27b99a538.jpeg',
      alt: 'Villa Tierra interior with colorful rainbow wall art'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/80fd1c39645389ee71ecf116e47e0e85.jpeg',
      alt: 'Villa Tierra terrace view with ocean and palm trees'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/7506a7a5b936323858192c992422e629.jpeg',
      alt: 'Villa Tierra colorful exterior and courtyard'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/a6944348e9df8ed379b57cf069e578b6.jpeg',
      alt: 'Villa Tierra serene bedroom with white decor'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/c89ceb296fcd76d80f3dede39da35f2b.jpeg',
      alt: 'Villa Tierra elegant bedroom with arched windows'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/a970332afc6cb60088910145312435ec.jpeg',
      alt: 'Villa Tierra bright living space with colorful wave mural'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/44569c8487440881ab2e3d0cc77d448a.jpeg',
      alt: 'Villa Tierra cozy bedroom with artistic wall mural'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/8462aeeac92e7bb56ca8f083e13f2268.jpeg',
      alt: 'Villa Tierra modern kitchen with white cabinets'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/b6b9a1bd74fa437f701d126f1e8b48d5.jpeg',
      alt: 'Villa Tierra modern bathroom with glass shower'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/a596327c86ab146a32e60251eec75e9a.jpeg',
      alt: 'Villa Tierra elegant bathroom with modern fixtures'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative h-[60vh] min-h-[500px]">
          <img
            src={images[0].url}
            alt={images[0].alt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 w-full">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">
                Villa Tierra
              </h1>
              <p className="text-xl text-white/90 max-w-2xl">
                Ground yourself in nature. Natural stone, wood elements, and a lush garden 
                courtyard create a deeply rooted, peaceful sanctuary.
              </p>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
                  About Villa Tierra
                </h2>
                <div className="prose prose-lg text-gray-600 space-y-4">
                  <p>
                    Villa Tierra embodies the grounding energy of the earth element. This beautiful 
                    sanctuary features natural materials, earthy tones, and organic textures that 
                    create a deeply calming and nurturing environment.
                  </p>
                  <p>
                    The villa's design celebrates connection to nature, with a private garden courtyard, 
                    natural stone features, and abundant plants that bring the outdoors in. Every detail 
                    has been thoughtfully chosen to support your journey of grounding and self-discovery.
                  </p>
                  <p>
                    Perfect for those seeking stability, balance, and a deep connection to the natural 
                    world, Villa Tierra offers a peaceful retreat where you can truly root yourself 
                    and find your center.
                  </p>
                </div>
              </div>

              <div className="bg-sand-50 rounded-2xl p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                  Villa Details
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-user-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Capacity</div>
                      <div className="text-gray-600">Sleeps 3-5 guests</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hotel-bed-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bedrooms</div>
                      <div className="text-gray-600">2 bedrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shower-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bathrooms</div>
                      <div className="text-gray-600">2 full bathrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-plant-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Outdoor Space</div>
                      <div className="text-gray-600">Private garden courtyard</div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleReserveClick}
                  className="w-full mt-8 bg-primary-500 hover:bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Reserve Villa Tierra
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery */}
        <section className="py-16 bg-sand-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Photo Gallery
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {images.map((image, index) => (
                <div 
                  key={index}
                  className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Amenities
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wifi-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">High-Speed WiFi</h3>
                <p className="text-sm text-gray-600">Stay connected throughout your stay</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-temp-cold-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Air Conditioning</h3>
                <p className="text-sm text-gray-600">Climate control in all rooms</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-restaurant-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Full Kitchen</h3>
                <p className="text-sm text-gray-600">Fully equipped for meal preparation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parking-box-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Free Parking</h3>
                <p className="text-sm text-gray-600">Complimentary on-site parking</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-service-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Daily Housekeeping</h3>
                <p className="text-sm text-gray-600">Keep your space fresh and clean</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-cake-2-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Organic Breakfast</h3>
                <p className="text-sm text-gray-600">Healthy breakfast included daily</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-plant-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Garden Courtyard</h3>
                <p className="text-sm text-gray-600">Private outdoor meditation space</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-yoga-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Yoga Space Access</h3>
                <p className="text-sm text-gray-600">Shared yoga and meditation areas</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary-50 to-sand-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
              Ready to Experience Villa Tierra?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Limited spots available for our upcoming retreats. Reserve your place in this 
              grounding sanctuary and begin your journey of transformation.
            </p>
            <button
              onClick={handleReserveClick}
              className="bg-primary-500 hover:bg-primary-600 text-white px-12 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Reserve Your Spot
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VillaTierraPage;